module.exports = __webpack_public_path__ + "static/faktai-50561fd98a53a72360fbbfe2746f1dba.png";